import { useState } from 'react'
import CommonDeleteModal from '../atoms/modal/CommonDeleteModal'
import ButtonCustom from '../atoms/button/ButtonCustom'
import styles from '../popups/popups.module.css'

export default function DeleteGuestListPopup({
	open,
	guest,
	onClose,
	onConfirmDelete,
	onArchiveInstead,
}) {
	const [acknowledged, setAcknowledged] = useState(false)

	const displayName =
		guest?.preferredName ||
		[guest?.firstName, guest?.lastName].filter(Boolean).join(' ').trim() ||
		guest?.email ||
		'this guest'

	const handleClose = () => {
		setAcknowledged(false)
		onClose?.()
	}

	const headingContent = (
		<>
			Permanently delete <span>{displayName}</span> from the guest list?
		</>
	)

	return (
		<CommonDeleteModal
			open={open}
			handleClose={handleClose}
			heading={headingContent}
			className={styles.deleteModal}
			ClassIcon={styles.detailModalIcon}
			data-cy="guest-delete-modal"
			footerContent={
				<>
					<ButtonCustom
						variant="outlined"
						type="button"
						size="lg"
						onClick={() => {
							onArchiveInstead?.(guest)
							handleClose()
						}}
						data-cy="guest-archive-instead"
					>
						Archive instead
					</ButtonCustom>
					<ButtonCustom
						variant="destructive"
						size="lg"
						disabled={!acknowledged}
						onClick={() => {
							onConfirmDelete?.(guest)
							handleClose()
						}}
						data-cy="guest-confirm-delete"
					>
						Delete permanently
					</ButtonCustom>
				</>
			}
		>
			<p style={{ marginBottom: 12 }}>
				We recommend archiving guests instead of deleting them. Archived guests are
				hidden from the default list.
			</p>
			<label
				style={{ display: 'flex', gap: 8, alignItems: 'flex-start', cursor: 'pointer' }}
			>
				<input
					type="checkbox"
					checked={acknowledged}
					onChange={(e) => setAcknowledged(e.target.checked)}
					data-cy="guest-delete-ack"
				/>
				<span>
					I understand delete is permanent and I have considered Archive.
				</span>
			</label>
		</CommonDeleteModal>
	)
}
